import TkDataTable from "../../../components/molecules/TkDataTable";
import { headList } from "../../SCRC070003/parts";

interface props {
  bodyList: any;
}

const StaffListTable: React.FC<props> = ({ bodyList }) => {
  return <TkDataTable headList={headList} bodyList={bodyList} pagin={true} />;
};

export default StaffListTable;
